// Modules
import cn from 'classnames';

// Types
import type { TSwitchProps } from './Switch.type';

// Styles
import styles from './styles.module.scss';

// Constants
import { INPUT_TYPE, SWITCH_DEFAULT_PROPS, SWITCH_LABEL_POSITION, SWITCH_TYPE } from './Switch.constant';

const Switch = (props: TSwitchProps) => {
	const {
		className,
		disabled,
		fieldClassName,
		id,
		inputClassName,
		label,
		labelClassName,
		labelPosition = SWITCH_DEFAULT_PROPS.labelPosition,
		size = SWITCH_DEFAULT_PROPS.size,
		toggleClassName,
		type = SWITCH_DEFAULT_PROPS.type,
		...restProps
	} = props;
	const inputId = id || Math.random().toString(36).substring(7);
	const inputType = type === SWITCH_TYPE.multiple ? INPUT_TYPE.checkbox : INPUT_TYPE.radio;
	const isLeftLabel = labelPosition === SWITCH_LABEL_POSITION.left;

	const switchCN = cn(styles.legion_switch, className, styles[size!], {
		[styles.disabled]: !!disabled,
		[styles.left_label]: isLeftLabel,
	});
	const inputCN = cn(styles.switch_input, inputClassName);
	const toggleCN = cn(styles.switch_toggle, toggleClassName);
	const fieldCN = cn(styles.switch_field, fieldClassName);
	const labelCN = cn(styles.switch_label, labelClassName);

	return (
		<div className={switchCN}>
			<div className={inputCN}>
				<input id={inputId} type={inputType} disabled={disabled} {...restProps}/>
				<span className={fieldCN}>
					<span className={toggleCN}/>
				</span>
			</div>
			{label && (
				<label htmlFor={inputId} className={labelCN}>
					{label}
				</label>
			)}
		</div>
	);
}

export default Switch;
